import { render } from "./RiProdcategory06.vue?vue&type=template&id=07c105a8"
import script from "./RiProdcategory06.vue?vue&type=script&lang=js"
export * from "./RiProdcategory06.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiProdcategory06.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07c105a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07c105a8', __exports__)) {
    api.reload('07c105a8', __exports__)
  }
  
  module.hot.accept("./RiProdcategory06.vue?vue&type=template&id=07c105a8", () => {
    api.rerender('07c105a8', render)
  })

}


export default __exports__